import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { Nothing } from 'components/Nothing/Nothing';
import { NOOP } from 'constants/actions';
import { useCallback, useEffect } from 'react';
import { geolocation } from 'services/geolocation/geolocation';
import { cookies } from 'utils/cookies/cookies';

declare global {
  interface Window {
    adaSettings: {
      adaReadyCallback: () => void;
    };
    adaEmbed: {
      setMetaFields: (metaFields: Record<string, string>) => void;
    };
  }
}

type AdaProps = {
  onLoad: () => void;
  onShow: () => void;
};

function Ada({ onLoad = NOOP, onShow = NOOP }: AdaProps) {
  const handleScriptLoad = useCallback(async () => {
    const fingerprint = cookies.read(PERMANENT_COOKIE_NAME) || '';
    const location = await geolocation.fetch();
    window.adaEmbed.setMetaFields({
      country: location.countryCode,
      fingerprint: fingerprint,
    });
    onLoad();
  }, [onLoad]);

  async function injectSnippet() {
    window.adaSettings = {
      adaReadyCallback: () => {
        onShow();
      },
    };

    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('id', '__ada');
    script.onload = handleScriptLoad;
    script.setAttribute('data-handle', 'flywire-generative');
    script.setAttribute('src', 'https://static.ada.support/embed2.js');

    document.body.appendChild(script);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: false positive
  useEffect(() => {
    injectSnippet();
  }, []);

  return <Nothing />;
}

export { Ada };
